import { useParams } from 'react-router-dom'

import { BasicTextEditorHandle } from '@factorialco/factorial-one-react/dist/experimental'

import { AIPageChat } from 'modules/meetings/components/AIPageChat'

interface AIChatProps {
  textEditorRef?: React.RefObject<BasicTextEditorHandle> | null | undefined
}

export const AIChat = ({ textEditorRef }: AIChatProps) => {
  const { id: meetingId } = useParams<{ id: string }>()
  return (
    <>{meetingId && <AIPageChat meetingId={Number(meetingId)} textEditorRef={textEditorRef} />}</>
  )
}
